import React, { useState, useEffect } from 'react';
import './SideBar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faList, faChevronLeft, faChevronRight, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';

interface SideBarProps {
  // You can add props here if your sidebar needs to be dynamic
}

const SideBar: React.FC<SideBarProps> = () => {
  const [isContracted, setIsContracted] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleSidebar = () => {
    setIsContracted(!isContracted);
  };

  // Update CSS custom property when sidebar state changes
  useEffect(() => {
    const sidebarWidth = isContracted ? '80px' : '220px';
    document.documentElement.style.setProperty('--sidebar-width', sidebarWidth);
  }, [isContracted]);

  const goToHome = () => {
    navigate('/dashboard/home');
  };

  const goToTransactions = () => {
    navigate('/dashboard/transactions');
  };

  const goToDailyReports = () => {
    navigate('/dashboard/daily-reports');
  };

  // Check if current route matches to determine active state
  const isHomeActive = location.pathname === '/dashboard/home' || location.pathname === '/dashboard';
  const isTransactionsActive = location.pathname === '/dashboard/transactions';
  const isDailyReportsActive = location.pathname === '/dashboard/daily-reports';

  return (
    <div className={`side-bar ${isContracted ? 'contracted' : ''}`}>
      <ul className={`sidebar-nav ${isContracted ? 'contracted' : ''}`}>
        <li 
          className={`sidebar-nav-item ${isHomeActive ? 'active' : ''}`} 
          onClick={goToHome} 
          style={{ cursor: 'pointer' }}
        >
          <FontAwesomeIcon icon={faHome} className="sidebar-nav-icon" />
          {!isContracted && <span>Inicio</span>}
        </li>
        <li 
          className={`sidebar-nav-item ${isTransactionsActive ? 'active' : ''}`} 
          onClick={goToTransactions}
        >
          <FontAwesomeIcon icon={faList} className="sidebar-nav-icon" />
          {!isContracted && <span>Transacciones</span>}
        </li>
        <li 
          className={`sidebar-nav-item ${isDailyReportsActive ? 'active' : ''}`} 
          onClick={goToDailyReports}
        >
          <FontAwesomeIcon icon={faFileAlt} className="sidebar-nav-icon" />
          {!isContracted && <span>Reportes Diarios</span>}
        </li>
        {/* <li className="sidebar-nav-item">
          <FontAwesomeIcon icon={faUsers} className="sidebar-nav-icon" />
          {!isContracted && <span>Usuarios</span>}
        </li> */}
      </ul>
      
      <div className="sidebar-toggle-section">
        <div className="sidebar-toggle-divider"></div>
        <div className={`sidebar-toggle ${isContracted ? 'contracted' : ''}`} onClick={toggleSidebar}>
          <FontAwesomeIcon icon={isContracted ? faChevronRight : faChevronLeft} />
        </div>
      </div>
    </div>
  );
};

export default SideBar;